/**
 * @desc 导出费用请款tms单
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  params: API.tms.costRequest.exportCostRequestTmsReport.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/costRequest/exportCostRequestTmsReport`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
